import { render, staticRenderFns } from "./NotificationsList.vue?vue&type=template&id=6597aa00&scoped=true&"
import script from "./NotificationsList.vue?vue&type=script&lang=js&"
export * from "./NotificationsList.vue?vue&type=script&lang=js&"
import style0 from "./NotificationsList.vue?vue&type=style&index=0&id=6597aa00&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6597aa00",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {NotificationsItem: require('/home/bitrix/frontend/components/sidebars/NotificationsAside/NotificationsItem.vue').default})
